var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import withBranding from "@irati/brand/withBranding";
import { BRAND_LOGO_DIMENSIONS } from "@irati/brand/constants/brand";
import Button from "@irati/ui/src/Button";
export var ColorCss = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: right;\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  margin-bottom: ", ";\n  cursor: pointer;\n"], ["\n  text-align: right;\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  margin-bottom: ", ";\n  cursor: pointer;\n"])), function (_a) {
    var small = _a.small;
    return small ? "180px" : "360px";
}, function (_a) {
    var small = _a.small;
    return small ? "90px" : "120px";
}, function (_a) {
    var branding = _a.branding, color = _a.color;
    return color || branding.primaryColour;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.two;
});
export var Color = withBranding(styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), ColorCss));
export var WithMargin = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-right: ", ";\n"], ["\n  margin-right: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.one;
});
export var ColorPreview = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ",
    "\n"])), ColorCss, function (_a) {
    var selectedId = _a.selectedId, itemId = _a.itemId;
    return (selectedId && selectedId !== itemId && "\n    opacity: 0.5;\n  ");
});
export var BrandSettingsChoiceImageWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px dashed ", ";\n  min-width: 360px;\n  height: 120px;\n  margin-bottom: ", ";\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px dashed ", ";\n  min-width: 360px;\n  height: 120px;\n  margin-bottom: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.mediumDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.two;
});
export var AlignButton = styled(Button)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  align-self: flex-start;\n"], ["\n  align-self: flex-start;\n"])));
export var BrandSettingsChoiceImage = styled.img(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n"], ["\n  width: ", "px;\n  height: ", "px;\n"])), BRAND_LOGO_DIMENSIONS.width, BRAND_LOGO_DIMENSIONS.height);
export var HexCode = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: inline-block;\n  position: relative;\n  top: 8px;\n  right: 8px;\n  font-family: ", ";\n  text-transform: uppercase;\n  color: ", ";\n  padding: 4px 8px;\n  background-color: ", ";\n  border-radius: 3px;\n"], ["\n  display: inline-block;\n  position: relative;\n  top: 8px;\n  right: 8px;\n  font-family: ", ";\n  text-transform: uppercase;\n  color: ", ";\n  padding: 4px 8px;\n  background-color: ", ";\n  border-radius: 3px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.font.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.utility.ink;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.utility.highlight;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
